import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FiPhoneCall } from "react-icons/fi";
import {
  MdOutlineLocalLaundryService,
  MdOutlineDesignServices,
  MdProductionQuantityLimits
} from "react-icons/md";
import { TbTruckDelivery } from "react-icons/tb";
import { BsChatRightHeart } from "react-icons/bs";
import { BiPackage, BiCheckCircle } from "react-icons/bi";

import numberOne from "../../Assets/numbers/number-1.png";
import numberTwo from "../../Assets/numbers/number-2.png";
import numberThree from "../../Assets/numbers/number-3.png";
import numberFour from "../../Assets/numbers/number-4.png";
import numberFive from "../../Assets/numbers/number-5.png";
import numberSix from "../../Assets/numbers/number-6.png";
import numberSeven from "../../Assets/numbers/number-7.png";
import RefillShop from "../RefillShop/RefillShop";
import TextCarousel from "../TextCarousel/TextCarousel";
import Seo, { breadcrumbSchema, privateLabelServiceSchema, webPageSchema } from "../Seo/Seo";

function Solution() {

  
  const serviceSteps = [
    {
      number: numberOne,
      title: "Free Samples",
      icon: <MdOutlineLocalLaundryService />,
      description: "Reach out to request laundry sheet samples from our Columbus, Ohio office so your team can compare performance, scent, and packaging direction."
    },
    {
      number: numberTwo,
      title: "Pick a Scent",
      icon: <BsChatRightHeart />,
      description: "From the more than 10 scent samples we sent, please choose the one that best aligns with your brand. Alternatively, we can work on creating a customized fragrance for you."
    },
    {
      number: numberThree,
      title: "Artwork",
      icon: <MdOutlineDesignServices />,
      description: "Send finished package artwork in .ai and .pdf formats, or talk with us early so packaging specs are clear before design starts."
    },
    {
      number: numberFour,
      title: "Package Samples",
      icon: <BiPackage />,
      description: "We’ll collaborate with our packaging team to create package samples. The first two paper bag versions are free; additional changes may incur fees."
    },
    {
      number: numberFive,
      title: "Approval",
      icon: <BiCheckCircle />,
      description: "Once you’re happy with the product, scent, and packaging, we’ll be ready to start your order whenever you give the go-ahead."
    },
    {
      number: numberSix,
      title: "MOQ",
      icon: <MdProductionQuantityLimits />,
      description: "MOQ starts at 1,000 retail package units per SKU."
    },
    {
      number: numberSeven,
      title: "Full Service",
      icon: <TbTruckDelivery />,
      description: "We coordinate manufacturing, packaging, customs, freight, and delivery planning so your team has clear support from sample approval through shipment."
    }
  ];

  return (
    <div className="service">
      <Container fluid className="service-page primary page-top-settings">
        <Seo
          title="Private Label Laundry Sheets & Wholesale Supply | Klean Leaf"
          description="Plan private label laundry sheets, wholesale supply, retail MOQ, refill shop cartons, custom laundry sheet packaging, samples, and delivery."
          path="/solution"
          schema={[
            privateLabelServiceSchema,
            webPageSchema({
              name: "Private Label Laundry Sheets & Wholesale Supply | Klean Leaf",
              description: "Plan private label laundry sheets, wholesale supply, retail MOQ, refill shop cartons, custom laundry sheet packaging, samples, and delivery.",
              path: "/solution",
            }),
            breadcrumbSchema([
              { name: "Home", path: "/" },
              { name: "Private Label Solutions", path: "/solution" },
            ]),
          ]}
        />
        <Container>
          <Row>
            <h1>Private Label Laundry Sheets Solutions</h1>
            <h2 className="page-title">
              From Sample Review to Bulk Delivery
            </h2>
            <p className="page-subtitle">Order process for brands, refill shops, wholesalers, and distributors</p>
          </Row>
          <Row>
            <h2 className="solution-option-title">Private Label Service Process</h2>
            {serviceSteps.map((step, index) => (
              <Col md={4} sm={6} xs={12} key={index} className={`mb-4 d-flex align-items-stretch ${index === serviceSteps.length - 1 ? 'align-self-start' : ''}`}>
                <Card className="service-card w-100">
                  <Card.Body>
                    <div className="card-top">
                      <img src={step.number} alt={`Step ${index + 1}`} className="step-number" />
                      <div className="step-icon">{step.icon}</div>
                    </div>
                    <Card.Title className="step-title">{step.title}</Card.Title>
                    <div className="step-description">
                      {step.description}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Row style={{ justifyContent: "center" }}>
            <a href="tel:614-906-5129" className="primary-btn">
              <FiPhoneCall />&nbsp;&nbsp;Talk to Our Team
            </a>
            <Link to="/contact" className="secondary-btn">
              Get a Custom Quote
            </Link>
          </Row>
        </Container>
      </Container>

      <TextCarousel />
      <RefillShop />
    

      
    </div>
  );
}

export default Solution;
